import { get } from 'lodash-es';
import { API_RESPONSE_STATUS, AXIOS_REQUEST_ERROR_TYPE } from '../config';
// reference: https://github.com/axios/axios#response-schema
const responseTemplate = Object.freeze({
    success: false,
    message: '',
    data: {},
    errorCode: '',
});
export const processApiResponse = async (promise, apiRoute, setApiProcessingPool, setApiDonePool) => {
    const isTriggerLoading = setApiProcessingPool && setApiDonePool;
    // trigger the loading animation
    if (isTriggerLoading)
        setApiProcessingPool((prev) => [...prev, apiRoute]);
    const processedApiResponse = await promise
        .then((response) => ({
        success: get(response, 'data.success'),
        message: get(response, 'data.message', ''),
        data: get(response, 'data.data'),
        errorCode: get(response, 'data.errorCode', null),
    }))
        .catch((error) => {
        // 1. The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response) {
            const defaultResponse = {
                ...responseTemplate,
                ...get(error, 'response.data', {}),
            };
            if (get(error, 'response.data.errorCode'))
                return defaultResponse;
            // reshape the api response with custom error code
            switch (error.response.status) {
                case API_RESPONSE_STATUS.FORBIDDEN.status:
                    return { ...responseTemplate, errorCode: API_RESPONSE_STATUS.FORBIDDEN.code };
                case API_RESPONSE_STATUS.NOT_FOUND.status:
                    return { ...responseTemplate, errorCode: API_RESPONSE_STATUS.NOT_FOUND.code };
                case API_RESPONSE_STATUS.INTERNAL_SERVER_ERROR.status:
                    return {
                        ...responseTemplate,
                        errorCode: API_RESPONSE_STATUS.INTERNAL_SERVER_ERROR.code,
                    };
                default:
                    return defaultResponse;
            }
        }
        // 2. Handle axios error
        return {
            ...responseTemplate,
            errorCode: AXIOS_REQUEST_ERROR_TYPE.NO_RESPONSE.code,
        };
    });
    // end the loading animation
    if (isTriggerLoading)
        setApiDonePool((prev) => [...prev, apiRoute]);
    return processedApiResponse;
};
